export const errors = {
  CasSessionManager: {
    logIn: {
      stateInvalid: {
        code: 'error.authentication.state.invalid',
        message: "[CasSessionManager][logIn] You can't login the user, session already exists",
      },
      apiCallInvalid: {
        code: 'error.authentication.api.call.invalid',
        message: '[CasSessionManager][logIn] Missing param',
      },
      operationFailed: {
        code: 'error.authentication.operation.failed',
        message: "[CasSessionManager][logIn] Couldn't initialise CAS",
      },
      empty: {
        code: '',
      },
    },
    logOut: {
      operationFailed: {
        code: 'error.authentication.operation.failed',
        message: '[CasSessionManager][logOut] operation failed',
      },
      stateInvalid: {
        code: 'error.authentication.state.invalid',
        message: '[CasSessionManager][logOut] Incorrect session state',
      },
    },
    getSessionToken: {
      operationFailed: {
        code: 'error.authentication.operation.failed',
        message: '[CasSessionManager][getSessionToken] Did not receive token',
      },
      stateInvalid: {
        code: 'error.authentication.state.invalid',
        message: '[CasSessionManager][getSessionToken] Incorrect SessionManager state',
      },
    },
  },
};
